<template>
<div>
  <btn type="success" size="lg" block @click="validate">Valider la fiche</btn>
  <modal v-model="show"
         :header="false"
         :backdrop="false"
         :footer="false">
    <h2>{{title}}</h2>
    <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
    <div v-if="completed">
      <btn @click="hide" type="default">Retour</btn>
    </div>
  </modal>
</div>
</template>
<script>
import assert from '@/sui/tools/assert'
import StepIterator from '@/sui/tools/stepiterator'
import impl from '@/components/sheet/impl/singleSheetValidator'
import steps from '@/sui/components/steps'

export default {
  name: 'validate-denominators',
  props: {
    surveillance: {
      type: Object,
      required: true
    },

    sheetType: {
      type: String,
      required: true
    }
  },

  data: function () {
    const t = this.sheetType
    assert(t === 'denominators' || t === 'toolsUsage')
    const data = impl.getStepsAndTitle(t)

    return {
      show: false,
      iterator: new StepIterator(data.steps),
      title: data.title
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    }
  },

  methods: {
    validate: function () {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
      this.$store.dispatch('surveillances/loadAll')
    }
  },

  components: {
    'steps': steps
  }
}
</script>
<style lang="less" scoped>
</style>
